<template>
  <el-dialog id="ff" :title="titles" :visible="visibleDialog" width="80%"  :before-close="closeEditDialogs" :close-on-click-modal="false" close-on-press-escape	>

    <el-container>
      <el-main>
        <div class="form-container">
          <el-divider></el-divider>
          <el-row>
            <el-col :span="12" style="padding-right: 15px;">
              <div class="section-left">
                <h3>校区基本信息</h3>
                <el-form >
                  <el-form-item label="创建日期:">
                    <el-date-picker v-model="input1" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择创建时间" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                  <el-form-item label="订单号（线下）:">
                    <el-input placeholder="请输入订单号（线下）" v-model="input2" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="微信名称（销售）:">
                    <el-input placeholder="请输入微信名称（销售）" v-model="input3" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="渠道:">
                    <el-input placeholder="请输入渠道" v-model="input4" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="老师名称:">
                    <el-input placeholder="请输入老师名称" v-model="input5" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="课时费:">
                    <el-input placeholder="请输入课时费" :maxlength="20" v-model="input6" clearable></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
            <el-col :span="12" style="padding-left: 15px;">
              <div class="section-right">
                <h3>学生基本信息</h3>
                <el-form >
                  <el-form-item label="学生名称:">
                    <el-input placeholder="请输入学生名称" v-model="input7" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="性别:">
                    <el-select v-model="input8" placeholder="请选择性别" style="width: 100%;" clearable>
                      <el-option label="男" value="男"></el-option>
                      <el-option label="女" value="女"></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="年级:">
                    <el-cascader clearable style="width: 100%;" v-model="input9" :options="gradeList" :props="props"></el-cascader>
                  </el-form-item>
                  <el-form-item label="手机号（家长）:">
                    <el-input :maxlength="11" placeholder="请输入手机号（家长）" v-model="input10" clearable></el-input>
                  </el-form-item>
                  <el-form-item label="科目:">
                    <el-input placeholder="请输入科目" v-model="input11" clearable></el-input>
                  </el-form-item>
                </el-form>
              </div>
            </el-col>
          </el-row>


          <div class="section-bottom">
            <h3>行规信息</h3>
            <el-form >
              <el-row :gutter="20">
                <el-col :span="4">
                  <el-form-item label="行规单次金额:">
                    <el-input placeholder="请输入行规单次金额" :maxlength="20" v-model="input12" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="总次数:">
                    <el-input placeholder="请输入总次数" :maxlength="20" v-model="input13" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="已付次数:">
                    <el-input placeholder="请输入已付次数" :maxlength="20" v-model="input14" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="剩余次数:">
                    <el-input placeholder="请输入剩余次数" :maxlength="20" v-model="input15" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="上课次数:">
                    <el-input placeholder="请输入上课次数" :maxlength="20" v-model="input19" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="4">
                  <el-form-item label="行规总额:">
                    <el-input placeholder="请输入行规总额" :maxlength="20" v-model="input16" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="已付总额:">
                    <el-input placeholder="请输入已付总额" :maxlength="20"  v-model="input17" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="剩余总额:">
                    <el-input placeholder="请输入剩余总额" :maxlength="20" v-model="input18" clearable></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="4">
                  <el-form-item label="退费金额:">
                    <el-input placeholder="请输入退费金额" :maxlength="20" v-model="input21" clearable :disabled="true"></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <h3>订单状态</h3>
            <el-form >
              <el-form-item label="订单状态:">
                <el-select v-model="input20" placeholder="请选择订单状态" style="width: 100%;">
                    <el-option label="已成单" value="1"></el-option>
                    <el-option label="已退费" value="2"></el-option>
                    <el-option label="未定" value="3"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <h3>退费情况</h3>
            <el-form >
              <el-form-item label="退费金额:">
                <el-input placeholder="请输入退费金额" :maxlength="20" v-model="input21" clearable></el-input>
              </el-form-item>
              <el-form-item label="退费时间:">
                <el-date-picker v-model="input22" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" placeholder="选择创建时间" style="width: 100%;"></el-date-picker>
              </el-form-item>
              <el-form-item label="是否到账:">
                <el-select v-model="input23" placeholder="请选择是否到账" style="width: 100%;">
                    <el-option label="是" value="1"></el-option>
                    <el-option label="否" value="2"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <h3>备注</h3>
            <el-form >
              <el-form-item label="输入内容:">
                <el-input type="textarea" maxlength="99999" placeholder="输入内容" :autosize="{ minRows: 6, maxRows: 6 }"  show-word-limit v-model="input24"></el-input>
              </el-form-item>
            </el-form>

          </div>
        </div>
      </el-main>
    </el-container>

    <!-- <el-form ref="" label-position="left" label-width="80px">
      <el-form-item label="姓名">
        <el-input clearable v-model="editFormData.realname" autocomplete="off"></el-input>
      </el-form-item>

      <el-form-item label="性别">
        <el-radio-group class="sex" style="margin-left: -75%;" v-model="editFormData.sex">
          <el-radio label="1">男</el-radio>
          <el-radio label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>

      <el-form-item label="学生状态">
          <el-select class="select" filterable  clearable v-model="editFormData.state" placeholder="请选择" style="width:100%;">
            <el-option v-for="item in classTypes_s" :key="item.value" :value="item.value" :label="item.label">
            </el-option>
          </el-select>
      </el-form-item>

      <el-form-item label="所属地域">

          <el-select v-model="regionName" clearable filterable placeholder="请选择所在地域" style="width:100%;">
              <el-option v-for="item in optionsListt" :key="item.id" :label="item.dictValue"
              :value="item.dictType"></el-option>
            </el-select>
      </el-form-item>

      <el-form-item label="微信">
        <el-input v-model="editFormData.wechat" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="年级" style="text-align: left;">
        <el-cascader clearable style="width: 100%;" v-model="editFormData.grades" :options="gradeList"
          :props="props"></el-cascader>
      </el-form-item>
      <el-form-item label="家长电话">
        <el-input v-model="editFormData.telephone" maxlength="11" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="家庭住址">
        <el-input v-model="editFormData.address" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item label="销售">
        <el-select class="select" filterable  clearable v-model="editFormData.saleId" placeholder="请选择销售" style="width:100%;">
          <el-option v-for="source in salesName" :key="source.id" :value="source.id" :label="source.realname">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跟进助理">
        <el-select class="select"  filterable  clearable v-model="editFormData.assistantId" placeholder="请选择跟进助理"
          style="width:100%;">
          <el-option v-for="source in Progressteacher" :key="source.id" :value="source.id" :label="source.realname">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="来源">
        <el-select class="select" filterable  clearable allow-create default-first-option v-model="editFormData.sourcepeopleId"
          placeholder="请选择或输入来源负责人" style="width:100%;">
          <el-option v-for="source in sourcesPeople" :key="source.sourcepeopleId" :value="source.sourcepeopleId"
            :label="source.sourcepeopleName">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="跟进老师">
        <el-select class="select" multiple filterable  clearable v-model="editFormData.progressTeacherIds" placeholder="请选择跟进老师"
          style="width:100%;">
          <el-option v-for="source in Progressteacher1" :key="source.id" :value="source.id" :label="source.realname">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="学生类型">
        <el-select class="select" filterable  clearable v-model="editFormData.classType" placeholder="请选择" style="width:100%;">
          <el-option v-for="item in classTypes" :key="item.value" :value="item.value" :label="item.label">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="预存课时">
        <el-input-number style="display: flex;width: 100%;" v-model="prestoreHoursNum"  :min="0" :max="999" ></el-input-number>
      </el-form-item>
      <el-form-item label="消除课时">
        <el-input-number style="display: flex;width: 100%;" v-model="eliminateHoursNum"  :min="0" :max="999" ></el-input-number>
      </el-form-item>
      <el-form-item label="所欠课时">
        <el-input-number style="display: flex;width: 100%;" v-model="arrearsHoursNum"  :min="0" :max="999" ></el-input-number>
      </el-form-item>

    </el-form> -->

    <div  class="dialog-footer">
      <el-button @click="cancel">取消</el-button>
      <el-button type="primary" @click="saveAdd">保存 </el-button>
      <!-- <el-button type="primary" @click="saveAddSubt()">保存 </el-button> -->
    </div>
  </el-dialog>
</template>

<script>
import axios from "axios";
import apiBaseUrl from "../../config/api";
export default {
  data () {
    return {
      titles:'',
      prestoreHoursNum: 0,
      eliminateHoursNum: 0,
      arrearsHoursNum: 0,
      classTypes_s: [{ value: 1, label: '在读' }, { value: 2, label: '结业' }, { value: 3, label: '停课' }, { value: 4, label: '流失' }],
      classTypes: [{ value: 1, label: '规划' }, { value: 2, label: '线下' }, { value: 3, label: '纯补课' }],
      gradeList: [],
      visibleDialog: false,
      editFormData: {
        state:"",
        classType: "",
        id: "",
        studentNo: "",
        username: "",
        realname: "",
        grades: [],
        classNo: "",
        telephone: "",
        email: "",
        address: "",
        sex: "",
        wechat: "",
        sourcepeopleId: "",
        saleId: "",
        progressTeacherName: [],
        progressTeacherIds: [],
        createTime: null,
        assistantId:'',
      },
      regionName: 1,
      Progressteacher: [],
      Progressteacher1: [],
      teacherData: [],
      sourcesPeople: [],
      salesName: [],
      // classTypes_ss: [{id:'北京',name:'北京'},{id:'深圳',name:'深圳'}],
      optionsListt:[
        // {dictValue:"北京", dictType:1 },
        // {dictValue:"深圳", dictType:2 },
      ],


      input1: '',
      input2: '',
      input3: '',
      input4: '',
      input5: '',
      input6: '',
      input7: '',
      input8: '',
      input9: [],
      input10: '',
      input11: '',
      input12: '',
      input13: '',
      input14: '',
      input15: '',
      input16: '',
      input17: '',
      input18: '',
      input19: '',
      input20: '',
      input21: '',
      input22: '',
      input23: '',
      input24: '',


      itmeRow:{},

      props: {
        label: "gradeName",
        children: "children",
        value: "id"
      },


    };
  },
  created () {
    this.getDataSoursePeople();
    this.getTeacher();
    this.teacherSale();
    this.getGrade()

    axios.get(`${ apiBaseUrl }/dict/getDictionary/${'地域'} `,
      { headers: { 'authorization': sessionStorage.getItem('tokenInfo') }
      }).then((res)=>{ this.optionsListt = res.data.data})
  },

  mounted () {

    axios.get(`${apiBaseUrl}/grade/getGrade`,{ headers:{'authorization': sessionStorage.getItem('tokenInfo')}}).then(res => {
      if (res.data.data.length > 0) {
        this.gradeList = res.data.data
      } else {
        this.$message({ message: "获取年级列表失败",type: "error" })
      }
    }).catch(error => {
       this.$message.error(error)
    })

  },
  methods: {

    saveAddSubt(){
      const data = {
        realname: this.editFormData.realname,
        sex: this.editFormData.sex,
        telephone: this.editFormData.telephone,
        address: this.editFormData.address,
        grades: this.editFormData.grades,
        wechat: this.editFormData.wechat,
        sourcepeopleId: null,
        progressTeacherIds: this.editFormData.progressTeacherIds,
        saleId: this.editFormData.saleId,
        sourceName: "",
        classType: this.editFormData.classType,
        prestore: this.prestoreHoursNum,
        eliminate: this.eliminateHoursNum,
        arrears: this.arrearsHoursNum,
        assistantId:this.editFormData.assistantId,
        regionName:this.regionName,
      };

      if (typeof this.editFormData.sourcepeopleId === 'number') {
        data.sourcepeopleId = this.editFormData.sourcepeopleId
      } else {
        data.sourceName = this.editFormData.sourcepeopleId
      }
      axios
        .post(`${apiBaseUrl}/student/addstudent`, data,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          // console.log(res, "pppppppppppp");
          if (res.data.code == 200) {
            //成功
            this.$message({
              message: res.data.message,
              type: "success"
            });
            this.visibleDialog = false;
            this.$emit("refresh");
          } else {
            //失败
            this.$message({
              message: res.data.message,
              type: "error"
            });
          }
        })
        .catch(err => {
          console.error(err);
        });
    },
    //获取年级
    getGrade () {
      axios
        .get(`${apiBaseUrl}/grade/getGrade`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          if (res.data.data.length > 0) {
            this.gradeList = res.data.data;
          } else {
            this.$message({
              message: "获取年级列表失败",
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },

    saveAdd () {
      const data = {
        createDate: this.input1 ? this.input1 : '',
        orderNumber: this.input2 ? this.input2 : '',
        wechatNumber: this.input3 ? this.input3 : '',
        channelName: this.input4 ? this.input4 : '',
        teacherName: this.input5 ? this.input5 : '',
        classFee: this.input6 ? this.input6 : '',
        studentName: this.input7 ? this.input7 : '',
        studentSex: this.input8 ? this.input8 : '',
        gradeName: this.input9 ? JSON.stringify(this.input9) : '',
        phoneNumber: this.input10 ? this.input10 : '',
        categoryName: this.input11 ? this.input11 : '',
        oneMoney: this.input12 ? this.input12 : '',
        totalDegree: this.input13 ? this.input13 : '',
        paidTotal: this.input14 ? this.input14 : '',
        residueTotal: this.input15 ? this.input15 : '',
        guildMoney: this.input16 ? this.input16 : '',
        paidMoney: this.input17 ? this.input17 : '',
        residueMoney: this.input18 ? this.input18 : '',
        classTotal: this.input19 ? this.input19 : '',
        orderType: this.input20 ? this.input20 : '',
        returnPremium: this.input21 ? this.input21 : '',
        returnPremiumDate: this.input22 ? this.input22 : '',
        isAccounting: this.input23 ? this.input23 : '',
        remark: this.input24 ? this.input24 : '',
        id: this.itmeRow.id ? this.itmeRow.id : '',
      }

      let url = this.itmeRow.id  ? 'customerBelow/modify' : 'customerBelow/add'

      axios.post(`${apiBaseUrl}/${url}`, data,{ headers:{'authorization': sessionStorage.getItem('tokenInfo') }}).then(res => {
        if (res.data.code == 200) {
            this.$message({  message: res.data.message, type: "success"})
            this.visibleDialog = false
            this.input1 = ''
            this.input2 = ''
            this.input3 = ''
            this.input4 = ''
            this.input5 = ''
            this.input6 = ''
            this.input7 = ''
            this.input8 = ''
            this.input9 = []
            this.input10 = ''
            this.input11 = ''
            this.input12 = ''
            this.input13 = ''
            this.input14 = ''
            this.input15 = ''
            this.input16 = ''
            this.input17 = ''
            this.input18 = ''
            this.input19 = ''
            this.input20 = ''
            this.input21 = ''
            this.input22 = ''
            this.input23 = ''
            this.input24 = ''
            this.$emit("refresh")
        } else {
           this.$message({ message: res.data.message, type: "error"})
        }
      }).catch(err => {
        this.$message({ message: err, type: "error"})
      })

    },
    init (isType,itmeRow) {
      this.titles = isType

      if(isType == '编辑'){
          this.itmeRow = itmeRow
          this.input1 = itmeRow.createDate ? itmeRow.createDate : ''
          this.input2 = itmeRow.orderNumber ? itmeRow.orderNumber : ''
          this.input3 = itmeRow.wechatNumber ? itmeRow.wechatNumber : ''
          this.input4 = itmeRow.channelName ? itmeRow.channelName : '',
          this.input5 = itmeRow.teacherName ? itmeRow.teacherName : ''
          this.input6 = itmeRow.classFee ? itmeRow.classFee : ''
          this.input7 = itmeRow.studentName ? itmeRow.studentName : ''
          this.input8 = itmeRow.teacherName ? itmeRow.studentSex : ''
          this.input9 = itmeRow.gradeName ? JSON.parse(itmeRow.gradeName) : []
          this.input10 = itmeRow.phoneNumber ? itmeRow.phoneNumber : ''
          this.input11 = itmeRow.categoryName ? itmeRow.categoryName : ''
          this.input12 = itmeRow.oneMoney ? itmeRow.oneMoney : ''
          this.input13 = itmeRow.totalDegree ? itmeRow.totalDegree : ''
          this.input14 = itmeRow.paidTotal ? itmeRow.paidTotal : ''
          this.input15 = itmeRow.residueTotal ? itmeRow.residueTotal : ''
          this.input16 = itmeRow.guildMoney ? itmeRow.guildMoney : ''
          this.input17 = itmeRow.paidMoney ? itmeRow.paidMoney : ''
          this.input18 = itmeRow.residueMoney ? itmeRow.residueMoney : ''
          this.input19 = itmeRow.classTotal ? itmeRow.classTotal : ''
          this.input20 = itmeRow.orderType ? itmeRow.orderType : ''
          this.input21 = itmeRow.returnPremium ? itmeRow.returnPremium : ''
          this.input22 = itmeRow.returnPremiumDate ? itmeRow.returnPremiumDate : ''
          this.input23 = itmeRow.isAccounting ? String(itmeRow.isAccounting)  : ''
          this.input24 = itmeRow.remark ? itmeRow.remark : ''
      }else{
        this.itmeRow = {}
      }

      this.visibleDialog = true;

      // this.editFormData = {};
      // //点击按钮表单清空
      // axios.post(`${apiBaseUrl}/teacher/query`, {   page: "",  limit: "",  realname: this.searchTeachers  },{  headers:{ 'authorization': sessionStorage.getItem('tokenInfo')  }  }) .then(res => {
      //     this.teacherData = res.data.data.list;
      // }) .catch(err => {
      //   console.log(err)
      // })


    },

    closeEditDialogs () {
      this.visibleDialog = false;
      this.regionName = 1

      this.input1 = ''
      this.input2 = ''
      this.input3 = ''
      this.input4 = ''
      this.input5 = ''
      this.input6 = ''
      this.input7 = ''
      this.input8 = ''
      this.input9 = []
      this.input10 = ''
      this.input11 = ''
      this.input12 = ''
      this.input13 = ''
      this.input14 = ''
      this.input15 = ''
      this.input16 = ''
      this.input17 = ''
      this.input18 = ''
      this.input19 = ''
      this.input20 = ''
      this.input21 = ''
      this.input22 = ''
      this.input23 = ''
      this.input24 = ''

    },


    cancel () {
      this.visibleDialog = false;
      this.regionName = 1

      this.input1 = ''
      this.input2 = ''
      this.input3 = ''
      this.input4 = ''
      this.input5 = ''
      this.input6 = ''
      this.input7 = ''
      this.input8 = ''
      this.input9 = ''
      this.input10 = ''
      this.input11 = ''
      this.input12 = ''
      this.input13 = ''
      this.input14 = ''
      this.input15 = ''
      this.input16 = ''
      this.input17 = ''
      this.input18 = ''
      this.input19 = ''
      this.input20 = ''
      this.input21 = ''
      this.input22 = ''
      this.input23 = ''
      this.input24 = ''


    },
    //客资来源负责人
    getDataSoursePeople () {
      axios
        .get(`${apiBaseUrl}/customerinformation/sourcepeoplelist`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        }) // 请替换为你的API URL
        .then(response => {
          this.sourcesPeople = response.data.data.list;
        })
        .catch(error => {
          console.error(error);
        });
    },
    //销售
    teacherSale () {
      axios
        .get(`${apiBaseUrl}/teacher/teacherSale`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          this.salesName = response.data.data
          // this.Progressteacher = response.data.data  //跟进老师
          // console.log(this.Progressteacher,"111");
          // console.log(response.data.data);
          // this.Progressteacher = response.data.data; //跟进老师
          // console.log(this.Progressteacher,"111");
          // console.log(response.data.data);
          // console.log(response,'hhhhhhgh')
        })
        .catch(error => {
          console.error(error);
        });
    },
    //跟进老师
    getTeacher () {
      axios
        .get(`${apiBaseUrl}/schedule/teacherDiagnosisList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          // this.salesName = response.data.data;
          this.Progressteacher1 = response.data.data; //跟进老师
          // console.log(this.Progressteacher,"111");
          // console.log(response.data.data);
          // console.log(response,'hhhhhhgh')
        })
        .catch(error => {
          console.error(error);
        });
      axios
        .get(`${apiBaseUrl}/schedule/assistantList`,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(response => {
          // this.salesName = response.data.data;
          this.Progressteacher = response.data.data; //跟进老师
          // console.log(this.Progressteacher,"111");
          // console.log(response.data.data);
          // console.log(response,'hhhhhhgh')
        })
        .catch(error => {
          console.error(error);
        });
    },

    // 点击编辑学生回显数据
    editById (index, row) {
      let modifyId = row.id;
      this.$axios
        .get(`${apiBaseUrl}/student/` + modifyId,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          this.editFormData.id = res.data.data.id; //学生id
          this.editFormData.studentNo = res.data.data.studentNo;
          this.editFormData.username = res.data.data.username;
          this.editFormData.realname = res.data.data.realname;
          this.editFormData.grade = res.data.data.grade;
          this.editFormData.classNo = res.data.data.classNo;
          this.editFormData.telephone = res.data.data.telephone;
          this.editFormData.email = res.data.data.email;
          this.editFormData.address = res.data.data.address;
          this.editFormData.age = res.data.data.age;
          this.editFormData.sex = res.data.data.sex + "";
          this.editFormData.wechat = res.data.data.wechat;
          this.editFormData.sourcepeopleId = res.data.data.sourcepeopleId;
          this.editFormData.progressTeacherName =
            res.data.data.progressTeacherName;
          this.editFormData.progressTeacherIds =
            res.data.data.progressTeacherIds;
          // console.log(res.data.data.progressTeacherName);
          this.editFormData.saleId = res.data.data.saleId;
          this.regionName  = res.data.data.regionName ? res.data.data.regionName : 1;
        })
        .catch(error => { });
      this.editFormData = row;
      this.visibleForm = true;
    },

    //编辑提交
    commit () {
      // console.log(this.editFormData.progressTeacherIds);
      this.editFormData.sex = this.editFormData.sex;
      this.modifyStudent(this.editFormData);
    },

    //更新学生
    modifyStudent (modifyData) {
      modifyData.createTime = null;

      this.$axios
        .post(
          `${apiBaseUrl}/student/modify/` + this.editFormData.id,
          modifyData
          ,{
          headers:{
            'authorization': sessionStorage.getItem('tokenInfo')
          }
        })
        .then(res => {
          // console.log(JSON.stringify(modifyData));
          this.$message({ message: "更新成功", type: "success" });
          this.allStudent();
          this.visibleForm = false;
        })
        .catch(error => {
          this.$message.error("更新失败");
        });
    }
  }
};
</script>

<style scoped>
/* 兼容移动端 */
@media screen and (max-width: 750px) {
  .dashboard-container {
    /* overflow: auto; */
    width: 1430px;
  }

  /* 兼容移动端 */

  #ff>>>.el-dialog {
    width: 70% !important;
  }
}





</style>



// WEBPACK FOOTER //
// src/CustomerFundingAll/EditStudents.vue